import { AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { ResizeObserver } from '@juggle/resize-observer';

export interface ImagePreviewData {
  tileImages: string[];
  rows: number;
  columns: number;
  height: number;
  width: number;
  description: string;
}

@Component({
  selector: 'lib-app-image-puzzle-preview',
  templateUrl: './image-puzzle-preview.component.html',
  styleUrls: ['./image-puzzle-preview.component.scss'],
  standalone: true,
  imports: [CommonModule, IonText],
})
export class ImagePuzzlePreviewComponent implements OnInit, AfterViewInit {
  @Input() rows: number;
  @Input() columns: number;
  @Input() height: number;
  @Input() width: number;
  @Input() copyright: string;
  @Input() tileImages: string[];

  tiles: number[][];
  show = false;

  tileHeight: number;
  tileWidth: number;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    // window.setTimeout(() => {
    this.showPreviewImage();
    // }, 1000);
  }

  private showPreviewImage() {
    this.scaleImage();
    this.show = true;
  }

  // @HostListener('window:resize')
  private scaleImage() {
    const availableHeight = this.el.nativeElement.offsetHeight - 20;
    const availableWidth = this.el.nativeElement.offsetWidth;
    const imageHeight = this.height;
    const imageWidth = this.width;
    const scaleValue = Math.min(availableHeight / imageHeight, availableWidth / imageWidth);

    this.tileHeight = (imageHeight / this.rows) * scaleValue;
    this.tileWidth = (imageWidth / this.columns) * scaleValue;
  }

  ngOnInit(): void {
    this.tiles = [];
    let index = 0;
    for (let row = 0; row < this.rows; row++) {
      this.tiles[row] = [];

      for (let column = 0; column < this.columns; column++) {
        this.tiles[row][column] = index;
        index++;
      }
    }

    const observer = new ResizeObserver((entries) => {
      this.scaleImage();
    });
    observer.observe(this.el.nativeElement);
  }
}
